import { IconType } from 'react-icons'

/** One hover action on a library card (ReportCard / DashboardCard). */
export type CardAction = {
  /** Accessible label, e.g. "Duplicate My Win Rate". */
  label: string
  icon: IconType
  onClick: () => void
}

/**
 * Action buttons pinned to a library card's top-right corner (e.g. duplicate /
 * delete). Sits as a sibling of the card's `<Link>` so a click acts instead of
 * navigating. Always visible (muted, brightening on card hover) so the actions
 * are discoverable without hunting for a hover target. Falsy entries are
 * dropped, so callers can pass `cond && {...}` inline; renders nothing when no
 * actions remain.
 *
 * @param actions - the actions to show, left to right (falsy entries ignored)
 */
export function CardActions({
  actions,
}: {
  actions: Array<CardAction | false | undefined>
}) {
  const shown = actions.filter((a): a is CardAction => Boolean(a))
  if (shown.length === 0) return null
  return (
    <div className="absolute top-2 right-2 flex gap-1">
      {shown.map((a) => (
        <button
          key={a.label}
          type="button"
          aria-label={a.label}
          onClick={a.onClick}
          className="rounded p-1.5 text-fg-muted transition-colors hover:bg-surface-hover hover:text-fg"
        >
          <a.icon size={14} />
        </button>
      ))}
    </div>
  )
}
